export default function Layer(name) {
  this.name = name;

  this.canvas = null;

  this.svgcanvas = null;
};